module.exports = __webpack_public_path__ + "static/media/11.97cf2251.jpg";